/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useEffect, useState } from 'react'
import { defaultConfig } from '../constants'
import { useTrack } from '../context/track'
import { TrackingEvent } from '../utils/tracking'

export const IbanGate: React.FC<{
  iban: string
  onSubmit: (iban?: string) => void
}> = ({ children, iban, onSubmit }) => {
  const [confirmed, setConfirmed] = useState(!iban)
  const [continueWithIban, setContinueWithIban] = useState(true)
  const track = useTrack()

  useEffect(() => {
    track(TrackingEvent.DACIBANGateShown)
  }, [track])

  if (!confirmed) {
    return (
      <div id="iban-gate">
        <p>
          Möchten Sie dieses Konto für die automatische Erstellung Ihres
          Kontoauszugs verwenden?
        </p>
        <div className="iban-box">
          <span className="title">IBAN</span>
          <span className="iban">{iban}</span>
        </div>
        <div className="iban-selector">
          <label
            htmlFor="iban-gate-checkbox-yes"
            className={continueWithIban ? 'active' : undefined}
            onClick={() => setContinueWithIban(true)}
          >
            <input
              name="selection"
              type="radio"
              id="iban-gate-checkbox-yes"
              checked={continueWithIban}
              readOnly
            />
            Ja
          </label>
          <label
            htmlFor="iban-gate-checkbox-no"
            className={!continueWithIban ? 'active' : undefined}
            onClick={() => setContinueWithIban(false)}
          >
            <input
              name="selection"
              type="radio"
              id="iban-gate-checkbox-no"
              checked={!continueWithIban}
              readOnly
            />
            Nein
          </label>
        </div>
        <button
          data-testid="IBAN-Gate-Button"
          type="button"
          onClick={async (e) => {
            e.preventDefault()
            if (continueWithIban) {
              track(TrackingEvent.DACIBANGateContinue)
              onSubmit(iban)
            } else {
              track(TrackingEvent.DACIBANGateSkip)
              onSubmit()
            }
            setConfirmed(true)
          }}
        >
          {defaultConfig['next-button-text']}
        </button>
      </div>
    )
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>
}
